import { useState } from "react";
import profileApi from "api/profile";
import useNotify from "hooks/useNotify";
import { useDispatch } from "react-redux";

import { useAppContext, useLookupsContext } from "hooks/useContext";
import { actions } from "store/actions";

function useAgencyForm({ agencyId }) {
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAppContext();
  const userId = user?.id;
  const dispatch = useDispatch();

  const { currencies = [] } = useLookupsContext(false);

  const { notifyError, notifySuccess } = useNotify();

  const defaultsValues = {
    //bankDetails
    vatRegistrationNumber: "",
    vatCertification: "",
    isVatExempt: false,
    vatCountryId: "",
    preferredCurrency: currencies.find((elem) => elem.code === "USD")?.id ?? "",
    fullName: "",
    cashExpressPhoneNumber: "",

    companyName: "",
    accountName: "",
    bankName: "",
    accountNumber: "",
    accountCurrency: "",
    swiftCode: "",
    iban: "",

    bankAddress: "",
    routingCode: "",
    sortCode: "",
    payoneer: "",

    //contacts
    contacts: [],
  };

  const onSubmit = async ({
    vatRegistrationNumber = "",
    vatCertification = "",
    isVatExempt = false,
    vatCountryId = "",
    preferredCurrency,
    fullName,
    cashExpressPhoneNumber,
    companyName,
    accountName,
    bankName,
    accountNumber,
    accountCurrency,
    swiftCode,
    iban,
    bankAddress,
    routingCode,
    sortCode,
    contacts,
    payoneer,
  }) => {
    setIsLoading(true);
    const bankDetails = {
      companyName,
      accountName,
      bankName,
      accountNumber,
      accountCurrency,
      swiftCode,
      iban,
      bankAddress,
      routingCode,
      sortCode,
    };
    const payoneerDetails = {
      payoneerEmail: payoneer,
    };
    const cashExpress = {
      fullName,
      cashExpressPhoneNumber,
    };

    const data = {
      bankDetails,
      preferredCurrency,
      cashExpress,
      contacts,
      vatRegistrationNumber,
      vatCertification,
      isVatExempt,
      vatCountry: vatCountryId,
      payoneerDetails,
    };

    try {
      await profileApi.updateAdditionalAgencyInfo(agencyId, data);
      notifySuccess("Has been updated successfully");

      const userData = await profileApi.getUserProfileByIdApi(userId);
      setTimeout(() => {
        dispatch(actions.setUserDetails(userData));
        window.scrollTo(0, 0);
      }, 400);
    } catch (err) {
      console.error(err);
      notifyError(err?.data?.error ?? err?.message ?? "Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };
  return { onSubmit, isLoading, defaultsValues };
}

export default useAgencyForm;
